export default {
  gotoGithub: 'open GitHub Page',
  tab: {
    about: 'About',
    coding: 'Coding',
    home: 'Home',
    throbax: {
      title: 'Throbax TD',
      index: 'Summary',
      screenShots: 'Screenshots'
    },
    code: {
      title: 'Free Code',
      explanation: 'Code Home',
      coding: 'Join Us Coding',
      git: 'Git Cheat-Sheet',
      cs: 'Free C# Libraries',
      java: 'Free Java Libraries'
    },
    cheatSheets: 'CheatSheets'
  }
}
